module.exports = __webpack_public_path__ + "static/waves-4f5c0bc5008e096ff9880e6188aea4dc.svg";